import { angularServicesNames } from "@topline/services/angularServicesNames";
import { ToasterService } from "@topline/services/toasterService";
import moment from "moment";
import { GridValueEditorService } from "../common/gridValueEditor/service/gridValueEditorService";

(function (module) {
    "use strict";

    module.component("mkshrProductForecast", {
        template: require("./mkshrProductForecastComponent.html"),
        bindings: {
            parameters: "<",
            marketForecast: "<",
            brand: "=",
            isEditable: "<"
        },
        controller: [
            "$scope",
            angularServicesNames.$translate,
            "mlDataService",
            "dtpChartService",
            "brandCalculationService",
            "skuCalculationService",
            "forecastCacheService",
            GridValueEditorService.componentName,
            ToasterService.componentName,
            function (
                this: $TSFixMe,
                $scope: $TSFixMe,
                $translate: ng.translate.ITranslateService,
                mlDataService: $TSFixMe,
                dtpChartService: $TSFixMe,
                brandCalculationService: $TSFixMe,
                skuCalculationService: $TSFixMe,
                forecastCacheService: $TSFixMe,
                gridValueEditorService: GridValueEditorService,
                toasterService: ToasterService
            ) {
                const $ctrl = this;

                $ctrl.gridPriceApi = {};

                $ctrl.iscollapsed = {};

                $ctrl.marketId = forecastCacheService.getForecast().market.id;

                $ctrl.tabDeselect = (index: $TSFixMe) => {
                    $ctrl.selectedTabIndex = index;
                };

                $ctrl.mkshrChanged = function () {
                    brandCalculationService.brandMkshrChanged($ctrl.brand, $ctrl.parameters);
                };

                $ctrl.skuPriceChanged = function () {
                    skuCalculationService.skuPriceChanged($ctrl.brand, $ctrl.parameters);
                };

                $ctrl.skuSplitChanged = function () {
                    skuCalculationService.skuSplitChanged($ctrl.brand, $ctrl.parameters);
                };

                $ctrl.loadFromRollingForecasts = function () {
                    const productCodes = $ctrl.brand.skus.map((s: $TSFixMe) => s.oracleIndex);
                    $ctrl.loadingMarketShare = mlDataService
                        .getRollingForecastWithPharmShare(
                            productCodes,
                            $ctrl.parameters.historicalDataEnd,
                            $ctrl.parameters.forecastStartDate,
                            $ctrl.parameters.forecastEndDate
                        )
                        .then((data: $TSFixMe) => {
                            if (_.isEmpty(data) || _.isEmpty(data.productVolume)) {
                                toasterService.warning("FORECAST.PRODUCT.MKSHR_RF_NO_DATA");
                                return;
                            }
                            for (let i = 0; i < $ctrl.mkshrInFirstYearGridOptions.header[1].headerLevel.length; i++) {
                                const mkshr =
                                    ((data.productVolume[i] * data.share) / $ctrl.marketForecast.pmForecast[i]) * 100;
                                $ctrl.brand.forecast.mkshr[i] = mkshr;
                            }
                            brandCalculationService.brandMkshrChanged($ctrl.brand, $ctrl.parameters);
                            refreshMkshInFirstYear();
                        });
                };

                $ctrl.$onInit = function () {
                    $ctrl.selectedTabIndex = 0;

                    $scope.$watchGroup(
                        ["$ctrl.parameters.forecastStartDate", "$ctrl.parameters.forecastEndDate"],
                        function () {
                            if (
                                $ctrl.parameters &&
                                $ctrl.parameters.forecastStartDate &&
                                $ctrl.parameters.forecastEndDate
                            ) {
                                var forecastData = dtpChartService.preparePeriodsAndLabels(
                                    $ctrl.parameters.forecastStartDate,
                                    $ctrl.parameters.forecastEndDate
                                );

                                var date = moment($ctrl.parameters.forecastStartDate).get("year") + 1;

                                $ctrl.mkrhDataEnd = moment.utc(date + "-12-01", "YYYY-MM-dd");
                                $ctrl.mkshrLength = forecastData.periods.indexOf(date + "-12") + 1;
                                $ctrl.forecastLength = forecastData.labels.length;
                                $ctrl.forecastStartMonth = $ctrl.parameters.forecastStartDate.getMonth();
                            }
                        }
                    );

                    $scope.$watch("$ctrl.brand", function () {
                        if (!$ctrl.brand) return;

                        populateDataToComponents();
                    });

                    $scope.$watch("$ctrl.parameters.forecastType.typeId", function (typeId: $TSFixMe) {
                        if (typeId)
                            $ctrl.marketVal =
                                $ctrl.productVal =
                                $ctrl.ppgVal =
                                    $ctrl.parameters.forecastType.typeId == "value";
                    });
                };

                function populateDataToComponents() {
                    var needPharmacyMarket = !areSkuNameUnique($ctrl.brand.skus);

                    let mkshrGridValueEditorData: $TSFixMe = [],
                        priceGridValueEditorData: $TSFixMe = [];

                    angular.forEach($ctrl.brand.skus, function (sku: $TSFixMe) {
                        var header = needPharmacyMarket ? sku.name + " - " + sku.pharmacyMarket : sku.name;

                        let histioricalMkshrValues = sku.forecast.historicalMkshr
                            ? _.map(sku.forecast.historicalMkshr.slice(-12), (x: $TSFixMe) => x * 100)
                            : _.times(12, _.constant(null));
                        mkshrGridValueEditorData.push({
                            header: header,
                            values: sku.forecast.mkshr,
                            historicalValues: histioricalMkshrValues
                        });

                        let historicalPriceValues = sku.forecast.historicalMkshr
                            ? sku.forecast.historicalPrice.slice(-12)
                            : _.times(12, _.constant(null));
                        priceGridValueEditorData.push({
                            header: header,
                            oracleIndex: sku.oracleIndex,
                            values: sku.forecast.price,
                            historicalValues: historicalPriceValues
                        });
                    });

                    $ctrl.sumMkhsr = prepareForecastSum($ctrl.brand.skus, "mkshr");

                    $ctrl.mkshrDataGridOptions = {
                        gridName: "mkshrDataGridOptions",

                        header: gridValueEditorService.prepareHeaderData(
                            moment.utc($ctrl.parameters.historicalDataEnd).add(-11, "months").toDate(),
                            $ctrl.parameters.forecastEndDate
                        ),
                        readOnlyCells: 12,
                        propagateData: true,
                        showPropagateButton: true,
                        readOnly: !$ctrl.isEditable,

                        gridData: _.sortBy(mkshrGridValueEditorData, "header"),
                        valuesSpecialEnd: "%",
                        valuesDecimalPlaces: 2,
                        validateFotter: true,
                        updateCell: function (input: $TSFixMe, idx: $TSFixMe, element: $TSFixMe) {
                            if ($ctrl.mkshrDataGridOptions.propagateData) {
                                for (
                                    let i = idx - $ctrl.mkshrDataGridOptions.readOnlyCells, max = element.values.length;
                                    i < max;
                                    i++
                                ) {
                                    element.values[i] = parseFloat(input);
                                }
                            } else {
                                element.values[idx - $ctrl.mkshrDataGridOptions.readOnlyCells] = parseFloat(input);
                            }
                            $ctrl.skuSplitChanged();
                            $ctrl.recalculateFooter();
                        },
                        showFooter: true,
                        footerData: new Array(12)
                            .fill(null)
                            .concat(
                                $ctrl.sumMkhsr.reduce((r: $TSFixMe, a: $TSFixMe) =>
                                    r.map((b: $TSFixMe, i: $TSFixMe) => a[i] + b)
                                )
                            )
                    };

                    $ctrl.recalculateFooter = () => {
                        let recalculateSum = prepareForecastSum($ctrl.brand.skus, "mkshr");
                        $ctrl.mkshrDataGridOptions.footerData = new Array(12)
                            .fill(null)
                            .concat(recalculateSum.reduce((r, a) => r.map((b: $TSFixMe, i: $TSFixMe) => a[i] + b)));
                    };

                    $ctrl.priceDataGridOptions = {
                        gridName: "priceDataGridOptions",

                        header: gridValueEditorService.prepareHeaderData(
                            moment.utc($ctrl.parameters.historicalDataEnd).add(-11, "months").toDate(),
                            $ctrl.parameters.forecastEndDate
                        ),
                        readOnlyCells: 12,
                        readOnly: !$ctrl.isEditable,
                        propagateData: true,
                        showPropagateButton: true,
                        valuesDecimalPlaces: 2,

                        gridData: _.sortBy(priceGridValueEditorData, "header"),
                        updateCell: function (input: $TSFixMe, idx: $TSFixMe, element: $TSFixMe) {
                            if ($ctrl.priceDataGridOptions.propagateData) {
                                for (
                                    let i = idx - $ctrl.priceDataGridOptions.readOnlyCells, max = element.values.length;
                                    i < max;
                                    i++
                                ) {
                                    element.values[i] = parseFloat(input);
                                }
                            } else {
                                element.values[idx - $ctrl.priceDataGridOptions.readOnlyCells] = parseFloat(input);
                            }

                            $ctrl.skuPriceChanged();
                        }
                    };

                    $ctrl.loadPrice = () => {
                        $ctrl.loadingPrice = mlDataService
                            .getPrices($ctrl.brand.skus.map((s: $TSFixMe) => s.oracleIndex))
                            .then((data: $TSFixMe) => {
                                if (_.isEmpty(data)) {
                                    toasterService.warning("FORECAST.PRODUCT.NO_PRICE_IN_PRICE_LIST");
                                    return;
                                }

                                for (const sku of $ctrl.brand.skus) {
                                    var price = data[sku.oracleIndex];

                                    if (!angular.isUndefinedOrNull(price)) {
                                        for (let i = 0; i < sku.forecast.price.length; i++) {
                                            sku.forecast.price[i] = price;
                                        }

                                        var gridData = _.find(
                                            $ctrl.priceDataGridOptions.gridData,
                                            (x: $TSFixMe) => x.oracleIndex == sku.oracleIndex
                                        );
                                        if (gridData) {
                                            gridData.values = sku.forecast.price;
                                        }
                                    }
                                }
                                $ctrl.skuPriceChanged();

                                $ctrl.priceDataGridOptions.gridData = $ctrl.priceDataGridOptions.gridData.slice();
                            });
                    };

                    $ctrl.mkshrInFirstYearGridOptions = {
                        gridName: "mkshrInFirstYear",
                        header: gridValueEditorService.prepareHeaderData(
                            $ctrl.parameters.forecastStartDate,
                            $ctrl.mkrhDataEnd
                        ),
                        cellWidth: 65,
                        readOnly: !$ctrl.isEditable,
                        propagateData: true,
                        showPropagateButton: true,
                        valuesDecimalPlaces: 2,
                        valuesSpecialEnd: "%",
                        updateCell: function (input: $TSFixMe, idx: $TSFixMe, element: $TSFixMe) {
                            if ($ctrl.mkshrInFirstYearGridOptions.propagateData) {
                                for (let i = idx, max = element.values.length; i < max; i++) {
                                    $ctrl.brand.forecast.mkshr[i] = parseFloat(input);
                                }
                            } else {
                                $ctrl.brand.forecast.mkshr[idx] = parseFloat(input);
                            }
                            $ctrl.mkshrChanged();
                            refreshMkshInFirstYear();
                        }
                    };

                    refreshMkshInFirstYear();
                }

                $ctrl.updateMkshrInFirstYear = (value: $TSFixMe) => {
                    for (let i = 0, max = value.length; i < max; i++) {
                        $ctrl.brand.forecast.mkshr[i] = value[i];
                    }
                    $ctrl.mkshrChanged();
                    refreshMkshInFirstYear();
                };

                function prepareForecastSum(arr: $TSFixMe, prop: $TSFixMe) {
                    let result: $TSFixMe = [];

                    angular.forEach(arr, (x: $TSFixMe) => {
                        result.push(x.forecast[prop]);
                    });
                    return result;
                }

                function areSkuNameUnique(skus: $TSFixMe) {
                    var groups = _.countBy(skus, function (sku: $TSFixMe) {
                        return sku.name;
                    });
                    var isUnique = true;
                    for (var propertyName in groups) {
                        if (groups[propertyName] > 1) {
                            isUnique = false;
                            break;
                        }
                    }
                    return isUnique;
                }

                function refreshMkshInFirstYear() {
                    $ctrl.mkshrInFirstYearGridOptions.gridData = [
                        {
                            header: "{{'FORECAST.PRODUCT.QUANTITATIVE_PARTICIPATION' | translate}}",
                            values: $ctrl.brand.forecast.mkshr.slice(
                                0,
                                $ctrl.mkshrInFirstYearGridOptions.header[1].headerLevel.length
                            ),
                            historicalValues: []
                        }
                    ];
                }
            }
        ]
    });
})(angular.module("topline.modules"));
